import {
  getCoinAddress,
  getCoinUsdtAddress,
  getCakeAddress,
  getCakeDaiAddress,
  getCakeUsdcAddress,
  getCakeUsdtAddress,
  getCakeWavaxAddress,
  getCakeWbtcAddress,
  getCakeWethAddress,
  getCornAddress,
  getCornUsdcAddress,
  getDaiAddress,
  getDaiUsdcAddress,
  getJoeAddress,
  getJoeUsdcAddress,
  getTmtAddress,
  getTmtUsdtAddress,
  getUsdcAddress,
  getUsdcUsdtAddress,
  getUsdtAddress,
  getWavaxAddress,
  getWavaxUsdcAddress,
  getWavaxUsdtAddress,
  getWavaxWethAddress,
  getWbtcAddress,
  getWbtcUsdcAddress,
  getWethAddress,
  getWethUsdcAddress,
} from 'utils/addressHelpers'
import contracts from './contracts'
import { FarmConfig, QuoteToken } from './types'

const farms: FarmConfig[] = [
  {
    pid: 21,
    risk: 5,
    isTokenOnly: true,
    lpSymbol: QuoteToken.CN,
    otherExchange: 'TraderJoe',
    decimal: 18,
    lpAddresses: {
      43114: getCoinUsdtAddress(), // XXXX COIN-USDT
    },
    tokenSymbol: QuoteToken.CN,
    tokenAddresses: {
      43114: getCoinAddress(), // XXXX ONION
    },
    quoteTokenSymbol: QuoteToken.AUSDT,
    quoteTokenAdresses: contracts.usdt,
  },

  {
    pid: 14,
    risk: 5,
    isTokenOnly: true,
    lpSymbol: QuoteToken.CAKE,
    otherExchange: 'TraderJoe',
    decimal: 18,
    lpAddresses: {
      43114: getCakeUsdtAddress(), // XXXX ONION-USDT
    },
    tokenSymbol: QuoteToken.CAKE,
    tokenAddresses: {
      43114: getCakeAddress(), // XXXX ONION
    },
    quoteTokenSymbol: QuoteToken.USDT,
    quoteTokenAdresses: contracts.usdt,
  },

  {
    pid: 15,
    risk: 5,
    lpSymbol: 'ONION-WAVAX LP',
    otherExchange: 'TraderJoe',
    decimal: 18,
    lpAddresses: {
      43114: getCakeWavaxAddress(), // XXXX ONION-WAVAX
    },
    tokenSymbol: QuoteToken.CAKE,
    tokenAddresses: {
      43114: getCakeAddress(), // XXXX ONION
    },
    quoteTokenSymbol: QuoteToken.WAVAX,
    quoteTokenAdresses: contracts.wavax,
  },

  {
    pid: 16,
    risk: 5,
    lpSymbol: 'ONION-USDC.e LP',
    otherExchange: 'TraderJoe',
    decimal: 18,
    lpAddresses: {
      43114: getCakeUsdcAddress(), // XXXX ONION-WAVAX
    },
    tokenSymbol: QuoteToken.CAKE,
    tokenAddresses: {
      43114: getCakeAddress(), // XXXX ONION
    },
    quoteTokenSymbol: QuoteToken.USDC,
    quoteTokenAdresses: contracts.usdc,
  },

  {
    pid: 17,
    risk: 5,
    lpSymbol: 'ONION-USDT.e LP',
    otherExchange: 'TraderJoe',
    decimal: 18,
    lpAddresses: {
      43114: getCakeUsdtAddress(), // XXXX ONION-USDT
    },
    tokenSymbol: QuoteToken.CAKE,
    tokenAddresses: {
      43114: getCakeAddress(), // XXXX ONION
    },
    quoteTokenSymbol: QuoteToken.USDT,
    quoteTokenAdresses: contracts.usdt,
  },

  {
    pid: 18,
    risk: 5,
    lpSymbol: 'ONION-WETH.e LP',
    otherExchange: 'TraderJoe',
    decimal: 18,
    lpAddresses: {
      43114: getCakeWethAddress(), // XXXX ONION-WAVAX
    },
    tokenSymbol: QuoteToken.CAKE,
    tokenAddresses: {
      43114: getCakeAddress(), // XXXX ONION
    },
    quoteTokenSymbol: QuoteToken.WETH,
    quoteTokenAdresses: contracts.weth,
  },

  {
    pid: 19,
    risk: 5,
    lpSymbol: 'ONION-WBTC.e LP',
    otherExchange: 'TraderJoe',
    decimal: 18,
    lpAddresses: {
      43114: getCakeWbtcAddress(), // XXXX ONION-WAVAX
    },
    tokenSymbol: QuoteToken.CAKE,
    tokenAddresses: {
      43114: getCakeAddress(), // XXXX ONION
    },
    quoteTokenSymbol: QuoteToken.WBTC,
    quoteTokenAdresses: contracts.wbtc,
  },

  {
    pid: 20,
    risk: 5,
    lpSymbol: 'ONION-DAI.e LP',
    otherExchange: 'TraderJoe',
    decimal: 18,
    lpAddresses: {
      43114: getCakeDaiAddress(), // XXXX ONION-WAVAX
    },
    tokenSymbol: QuoteToken.CAKE,
    tokenAddresses: {
      43114: getCakeAddress(), // XXXX ONION
    },
    quoteTokenSymbol: QuoteToken.DAI,
    quoteTokenAdresses: contracts.dai,
  } /*

  {
    pid: 21,
    risk: 5,
    lpSymbol: 'ONION-JOE LP',
    otherExchange: 'TraderJoe',
    decimal: 18,
    lpAddresses: {
      43114: getCakeJoeAddress() // XXXX ONION-WAVAX
    },
    tokenSymbol: QuoteToken.CAKE,
    tokenAddresses: {
      43114: getCakeAddress() // XXXX ONION
    },
    quoteTokenSymbol: QuoteToken.JOE,
    quoteTokenAdresses: contracts.joe,
  }, */,

  {
    pid: 12,
    risk: 5,
    isTokenOnly: true,
    lpSymbol: 'TMT',
    otherExchange: 'TraderJoe',
    decimal: 18,
    lpAddresses: {
      43114: getTmtUsdtAddress(), // XXXXTMT-USDT
    },
    tokenSymbol: 'TMT',
    tokenAddresses: {
      43114: getTmtAddress(), // XXXXTMT
    },
    quoteTokenSymbol: QuoteToken.USDT,
    quoteTokenAdresses: contracts.usdt,
  },

  {
    pid: 10,
    risk: 5,
    isTokenOnly: true,
    lpSymbol: 'CORN',
    otherExchange: 'Pangolin',
    decimal: 18,
    lpAddresses: {
      43114: getCornUsdcAddress(), // XXXXCORN-USDC
    },
    tokenSymbol: 'CORN',
    tokenAddresses: {
      43114: getCornAddress(), // XXXXCORN
    },
    quoteTokenSymbol: QuoteToken.USDC,
    quoteTokenAdresses: contracts.usdc,
  },

  {
    pid: 0,
    risk: 5,
    isTokenOnly: true,
    lpSymbol: 'WAVAX',
    otherExchange: 'TraderJoe',
    decimal: 18,
    lpAddresses: {
      43114: getWavaxUsdcAddress(),
    },
    tokenSymbol: 'WAVAX',
    tokenAddresses: {
      43114: getWavaxAddress(),
    },
    quoteTokenSymbol: QuoteToken.USDC,
    quoteTokenAdresses: contracts.usdc,
  },

  {
    pid: 1,
    risk: 5,
    isTokenOnly: true,
    lpSymbol: 'WETH.e',
    otherExchange: 'TraderJoe',
    decimal: 18,
    lpAddresses: {
      43114: getWethUsdcAddress(),
    },
    tokenSymbol: 'WETH.e',
    tokenAddresses: {
      43114: getWethAddress(),
    },
    quoteTokenSymbol: QuoteToken.USDC,
    quoteTokenAdresses: contracts.usdc,
  },

  {
    pid: 2,
    risk: 5,
    isTokenOnly: true,
    lpSymbol: 'WBTC.e',
    otherExchange: 'TraderJoe',
    decimal: 8,
    lpAddresses: {
      43114: getWbtcUsdcAddress(),
    },
    tokenSymbol: 'WBTC.e',
    tokenAddresses: {
      43114: getWbtcAddress(),
    },
    quoteTokenSymbol: QuoteToken.USDC,
    quoteTokenAdresses: contracts.usdc,
  },

  {
    pid: 3,
    risk: 5,
    isTokenOnly: true,
    lpSymbol: 'JOE',
    otherExchange: 'TraderJoe',
    decimal: 18,
    lpAddresses: {
      43114: getJoeUsdcAddress(),
    },
    tokenSymbol: 'JOE',
    tokenAddresses: {
      43114: getJoeAddress(),
    },
    quoteTokenSymbol: QuoteToken.USDC,
    quoteTokenAdresses: contracts.usdc,
  },

  {
    pid: 4,
    risk: 5,
    isTokenOnly: true,
    lpSymbol: 'USDT.e',
    otherExchange: 'TraderJoe',
    decimal: 6,
    lpAddresses: {
      43114: getUsdcUsdtAddress(),
    },
    tokenSymbol: 'USDT.e',
    tokenAddresses: {
      43114: getUsdtAddress(),
    },
    quoteTokenSymbol: QuoteToken.USDC,
    quoteTokenAdresses: contracts.usdc,
  },

  {
    pid: 5,
    risk: 5,
    isTokenOnly: true,
    lpSymbol: 'USDC.e',
    otherExchange: 'TraderJoe',
    decimal: 6,
    lpAddresses: {
      43114: getWavaxUsdcAddress(),
    },
    tokenSymbol: 'USDC.e',
    tokenAddresses: {
      43114: getUsdcAddress(),
    },
    quoteTokenSymbol: QuoteToken.WAVAX,
    quoteTokenAdresses: contracts.wavax,
  },

  {
    pid: 6,
    risk: 5,
    isTokenOnly: true,
    lpSymbol: 'DAI.e',
    otherExchange: 'TraderJoe',
    decimal: 18,
    lpAddresses: {
      43114: getDaiUsdcAddress(),
    },
    tokenSymbol: 'DAI.e',
    tokenAddresses: {
      43114: getDaiAddress(),
    },
    quoteTokenSymbol: QuoteToken.USDC,
    quoteTokenAdresses: contracts.usdc,
  },

  {
    pid: 13,
    risk: 5,
    lpSymbol: 'TMT-USDT.e LP',
    otherExchange: 'TraderJoe',
    decimal: 18,
    lpAddresses: {
      43114: getTmtUsdtAddress(), // XXXXTMT-USDT
    },
    tokenSymbol: 'TMT',
    tokenAddresses: {
      43114: getTmtAddress(), // XXXXTMT
    },
    quoteTokenSymbol: QuoteToken.USDT,
    quoteTokenAdresses: contracts.usdt,
  },

  {
    pid: 11,
    risk: 5,
    lpSymbol: 'CORN-USDC.e LP',
    otherExchange: 'Pangolin',
    decimal: 18,
    lpAddresses: {
      43114: getCornUsdcAddress(),
    },
    tokenSymbol: 'CORN',
    tokenAddresses: {
      43114: getCornAddress(),
    },
    quoteTokenSymbol: QuoteToken.USDC,
    quoteTokenAdresses: contracts.usdc,
  },

  {
    pid: 7,
    risk: 5,
    lpSymbol: 'WAVAX-USDT.e LP',
    otherExchange: 'Pangolin',
    decimal: 18,
    lpAddresses: {
      43114: getWavaxUsdtAddress(),
    },
    tokenSymbol: 'WAVAX',
    tokenAddresses: {
      43114: getWavaxAddress(),
    },
    quoteTokenSymbol: QuoteToken.USDT,
    quoteTokenAdresses: contracts.usdt,
  },

  {
    pid: 8,
    risk: 5,
    lpSymbol: 'WAVAX-WETH.e LP',
    otherExchange: 'Pangolin',
    decimal: 18,
    lpAddresses: {
      43114: getWavaxWethAddress(),
    },
    tokenSymbol: 'WETH.e',
    tokenAddresses: {
      43114: getWethAddress(),
    },
    quoteTokenSymbol: QuoteToken.WAVAX,
    quoteTokenAdresses: contracts.wavax,
  },

  {
    pid: 9,
    risk: 5,
    lpSymbol: 'USDC.e-USDT.e LP',
    otherExchange: 'Pangolin',
    decimal: 18,
    lpAddresses: {
      43114: getUsdcUsdtAddress(),
    },
    tokenSymbol: 'USDT.e',
    tokenAddresses: {
      43114: getUsdtAddress(),
    },
    quoteTokenSymbol: QuoteToken.USDC,
    quoteTokenAdresses: contracts.usdc,
  },
]

export default farms
